(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/models/person-data.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/models/person-data.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.models.PersonData = svs.terms_integrity.models.Base.extend({
    initialize: function() {
      if (svs.terms_integrity.data && svs.terms_integrity.data.personData) {
        this.set({
          personData: svs.terms_integrity.data.personData || {}
        });
      } else {
        this.getDocumentsFromCMS('personData');
      }
      this.getFaqFromCMS('faqPersonData');
    }
  });
})(Backbone, svs);

 })(window);